import {connect} from 'react-redux'
import LeaderboardV2Header from '../components/leaderboardV2_header'

const mapStateToProps = (state) => ({
  leagueId: state.leaderboardV2.leagueId,
  leagueName: state.leaderboardV2.leagueName,
})

export default connect(mapStateToProps)(LeaderboardV2Header)
